import React, { useCallback } from "react";
import { Drivers } from "../../../../../../modules/API/Drivers/drivers";
import {
  IActionLog,
  IKavDataItem,
} from "../../../../../../modules/API/Drivers/models/kavData";
import { appendKavAction } from "../../helpers/driversState";

export interface IUseKavActions {
  handleActionMovments: (kavID: number, action: number) => Promise<void>;
}

export const useKavActions = (deps: {
  setData: React.Dispatch<React.SetStateAction<IKavDataItem[] | null>>;
  date: string;
}): IUseKavActions => {
  const { setData, date } = deps;

  const handleActionMovments = useCallback(
    async (kavID: number, action: number) => {
      const postData = {
        Action: action,
        ActionTblCode: 0,
        Delivery_Date: date,
        PersonID: 0,
        PersonType: 1,
        ReferenceId: kavID,
        ReferenceType: 3,
        TransferZone: kavID,
      };
      try {
        const res: IActionLog[] = await Drivers.logStatusDelivery([postData]);
        setData((prev) => (prev ? appendKavAction(prev, kavID, res[0]) : prev));
      } catch {
        // легаси молча проглатывал ошибку
      }
    },
    [date, setData]
  );

  return { handleActionMovments };
};

export default useKavActions;
